<template>
  <header class="site-header-full-width">
    <div class="header-main flex ">
      <div class="flex w-full items-center">
        <LayoutHeaderLogo />
        <LayoutHeaderHeaderNavigation class="ml-auto" />
        <LayoutHeaderHeaderActions 
          :current-locale="currentLocale" 
          :fallback-locale="locale"
          @toggle-offcanvas="isOffcanvasOpen = !isOffcanvasOpen"
          @locale-change="handleLocaleChange"
        />
      </div>
    </div>
  </header>

  <Transition name="floating-header">
    <header v-show="isFloatingVisible" class="site-header-full-width site-header-full-width--floating">
      <div class="header-main flex ">
        <div class="flex w-full items-center">
          <LayoutHeaderLogo />
          <LayoutHeaderHeaderNavigation class="ml-auto" />
          <LayoutHeaderHeaderActions 
            :current-locale="currentLocale" 
            :fallback-locale="locale"
            @toggle-offcanvas="isOffcanvasOpen = !isOffcanvasOpen"
            @locale-change="handleLocaleChange"
          />
        </div>
      </div>
    </header>
  </Transition>

  <LayoutHeaderMobileOffcanvas 
    :is-open="isOffcanvasOpen" 
    :current-locale="currentLocale"
    :fallback-locale="locale"
    @close="isOffcanvasOpen = false"
    @locale-change="handleLocaleChange"
  />
</template>

<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref } from 'vue'
import { useRouteLocale, useLocaleSwitch } from '@/composables/locale'

const isOffcanvasOpen = ref(false)
const isFloatingVisible = ref(false)
const FLOATING_MENU_SCROLL_PX = 400

const { locale } = useI18n()
const { updateRouteLocale } = useRouteLocale()
const { currentLocale, changeLocale } = useLocaleSwitch({ updateRouteLocale })

const syncFloatingVisibility = () => {
  if (!import.meta.client) return
  isFloatingVisible.value = window.scrollY >= FLOATING_MENU_SCROLL_PX
}

onMounted(() => {
  syncFloatingVisibility()
  if (!import.meta.client) return
  window.addEventListener('scroll', syncFloatingVisibility, { passive: true })
})

onBeforeUnmount(() => {
  if (!import.meta.client) return
  window.removeEventListener('scroll', syncFloatingVisibility)
})

/**
 * Обработчик изменения локали - единственный источник истины для изменения локали
 */
const handleLocaleChange = async (newLocale: string) => {
  await changeLocale(newLocale)
}
</script>

<style scoped>
.site-header-full-width {
  position: relative;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.site-header-full-width--floating {
  position: fixed;
  z-index: 200;
}

.floating-header-enter-active,
.floating-header-leave-active {
  transition: opacity 180ms ease, transform 180ms ease;
}

.floating-header-enter-from,
.floating-header-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}

.header-main {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  max-width: 1677px;
  width: 90%;
  margin: 0 auto;
  background: #fff;
  padding: 15px 30px;
}

@media (max-width: 1024px) {
  .main-nav {
    display: none;
  }
}

@media (max-width: 768px) {
  .header-main {
    width: 95%;
    padding: 15px 20px;
  }
}

@media (max-width: 480px) {
  .header-main {
    margin: 0px 15px 0 15px;
    width: auto;
    padding: 12px 9px;
    box-sizing: border-box;
  }
}
</style>
